export default __webpack_public_path__ + "static/media/NIAS0180.34I-33115_-18189_0.ecf4d927.jpg";